module.exports = __webpack_public_path__ + "img/7.ec6b5e72.png";